<template>
  <div
    v-if="backgroundStyle"
    class="w-full"
  >
    <div
      class="h-[40rem]"
      :style="backgroundStyle"
    >
      <div class="flex justify-center grid grid-rows-4 h-full py-16">
        <div />

        <div class="flex justify-center">
          <!-- eslint-disable vue/no-v-html -->
          <div
            class="my-auto text-center font-bold text-white text-2xl sm:text-4xl drop-shadow-md w-full lg:w-[40rem]"
            :style="{
              textShadow: `
                -1px -1px 0 #000,
                1px -1px 0 #000,
                -1px 1px 0 #000,
                1px 1px 0 #000
              `,
            }"
            v-html="__('lander_001_footer_text')"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>

        <div class="w-full lg:w-[80rem] grid grid-cols-1 lg:grid-cols-3">
          <FooterBlock
            :color="blockOneColor"
            :text="__('lander_001_footer_block_one_text')"
          />

          <FooterBlock
            :color="blockTwoColor"
            :text="__('lander_001_footer_block_two_text')"
          />

          <FooterBlock
            :color="blockThreeColor"
            :text="__('lander_001_footer_block_three_text')"
          />
        </div>

        <div class="flex justify-center my-auto">
          <div
            class="w-[18rem] h-[4rem] cursor-pointer p-4 rounded-md shadow-md"
            :style="{
              backgroundColor: `#${secondaryColor}`,
            }"
            @click="scrollToTop()"
          >
            <p class="text-center text-white text-xl uppercase font-semibold">
              {{ __('label_get_started_now') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import FooterBlock from '@timon/js/Templates/LANDER-001/Components/FooterBlock.vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  backgroundStyle: {
    type: [Object, null],
    required: true,
  },
});

const secondaryColor = ref(props.config.style?.secondary);

const blockOneColor = ref(props.config.style?.footer_block_one);
const blockTwoColor = ref(props.config.style?.footer_block_two);
const blockThreeColor = ref(props.config.style?.footer_block_three);

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
</script>
